import request from '@/utils/request';

//错题列表
export async function wrongList(params: any): Promise<any> {
  return request(`/api/v1/pb/questions/wrong/${params}`);
}

//错题题目
export async function wrongTopicList(params: any): Promise<any> {
  return request(`/api/v1/pb/papers/${params.id}/wrong`);
}

//错题题目
export async function collectionTopicList(params: any): Promise<any> {
  return request(`/api/v1/pb/papers/${params.id}/collection`);
}

//我的试卷
export async function upQuestionApi(params: any): Promise<any> {
  return request(`/api/v1/pb/question`, {
    method: 'post',
    data: params,
  });
}

//删除错误试卷
export async function deleteQuestionApi(params: any): Promise<any> {
  return request(`/api/v1/pb/wrongs`, {
    method: 'DELETE',
    data: params,
  });
}
